import defaultBanner1 from "@assets/images/variant-jaangal/defaults/banner-1.jpg";
import defaultBanner2 from "@assets/images/variant-jaangal/defaults/banner-2.jpg";
import defaultBanner3 from "@assets/images/variant-jaangal/defaults/banner-3.jpg";

export function getBanner(id: string): string {
	return [defaultBanner1, defaultBanner2, defaultBanner3][id.charCodeAt(0) % 3];
}
